import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { IconName } from '@fortawesome/free-regular-svg-icons';

@Component({
  selector: 'sigecom-classification',
  template: `
    <div class="overflow-hidden rounded-t-2xl">
      <table class="w-full">
        <thead class="bg-[#012169] shadow-lg z-10 relative">
          <tr>
            <th
              class="w-[36rem] border-2 p-3 text-white"
              *ngFor="let coluna of colunas"
              [ngClass]="{
                'w-[36rem]': coluna.label === 'Participante'
              }"
            >
              {{ coluna.label }}
            </th>
          </tr>
        </thead>
        <tbody class="border-2 rounded-b-2xl border-[#ECEDF2] bg-white">
          <tr class="border-2" *ngFor="let item of dadosFiltered">
            <td
              class="border-2 text-[#012169] p-2"
              *ngFor="let coluna of colunas"
              [attr.data-label]="coluna.label"
            >
              <div class="flex justify-center gap-2">
                <!-- Condição para coluna "Pos." -->
                <ng-container
                  *ngIf="coluna.label === 'Pos.'; else defaultContent"
                >
                  {{ item[coluna.propriedade] }} <span>°</span>
                </ng-container>

                <!-- Conteúdo padrão -->
                <ng-template #defaultContent>
                  <p>{{ item[coluna.propriedade] }}</p>
                </ng-template>

                <!-- Botão apenas na coluna "Participante" -->
                <div *ngIf="coluna.label === 'Participante'">
                  <sigecom-menu-bar-item
                    (clickAction)="clickActionButton(item)"
                    [icon]="iconButton"
                    color="sigecom-info"
                    [title]="titleIcon"
                  />
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  `,
})
export class KeyClassificationComponent implements OnChanges {
  @Input() colunas: any[] = [];
  @Input() dados: any[] = [];
  @Input() colunaWith?: string;
  @Input() iconButton?: IconName;
  @Input() titleIcon?: string;
  @Input() cheQtdVencedores: number = 0;

  @Input() clickAction: boolean = false;

  @Output() dadosOut = new EventEmitter<any>();

  @Output() clickActionEmit = new EventEmitter<boolean>();

  dadosFiltered: any[] = [];
  dadosTemp: any[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['dados']) {
      let dados = changes['dados'].currentValue
      this.dadosTemp = dados;
      this.filterData();
    }
    if (changes['cheQtdVencedores']) {
      this.filterData();
    }

  }

  private filterData(): void {
  this.dadosFiltered = this.dadosTemp;
  }

  clickActionButton(item: any) {
    this.dadosOut.emit(item);
    this.clickAction = !this.clickAction;
    this.clickActionEmit.emit(this.clickAction);
  }
}
